const state = {
  race: {},
  runners: [],
  types: [],
  isRaceLive: false
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/races/state.js